<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">
            <span v-if="enterprise">{{ enterprise.name }}</span> Settings & Vendors
          </h6>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <b-row>
        <b-col md="4">
          <b-card no-body v-if="enterprise && enterprise.landing_page">
            <b-card-header>
              <h3 class="mb-0">Add Agents</h3>
            </b-card-header>
            <b-card-body>
              <b-row>
                <b-col>
                  <b-form-group size="sm" label="Copy Registration URL:" label-class="form-control-label">
                    <b-input-group>
                      <b-form-input type="url" :value="inviteLink" ref="inviteLink" readonly @focus="$event.target.select()"></b-form-input>
                      <template #append>
                        <b-button variant="success" @click="copyInviteLink"><i class="fas fa-copy"></i></b-button>
                      </template>
                    </b-input-group>
                  </b-form-group>
                  <div class="mb-4 h3 text-center">OR</div>
                  <b-button block variant="success" v-b-modal.enterprise-invite>Send Invite</b-button>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
          <b-card no-body v-if="enterprise">
            <b-card-header>
              <h3 class="mb-0">Settings</h3>
            </b-card-header>
            <b-card-body>
              <b-form @submit.prevent="update">
                <b-row>
                  <b-col md="6">
                    <base-input type="color" label="Primary Color" name="Primary Color" placeholder="Primary Color" v-model="enterprise.primary_color" rules="required" />
                  </b-col>
                  <b-col md="6">
                    <base-input type="color" label="Secondary Color" name="Secondary Color" placeholder="Secondary Color" v-model="enterprise.secondary_color" rules="required" />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <label class="form-control-label">Logo</label>
                    <file-input @change="logoUpload"></file-input>
                    <img :src="'https://vapor-us-east-1-1603342423.s3.amazonaws.com/' + enterprise.logo" class="w-100" v-if="enterprise.logo">
                  </b-col>
                </b-row>
                <b-row class="mt-4">
                  <b-col class="text-center">
                    <base-button block type="success" native-type="submit">Update</base-button>
                  </b-col>
                </b-row>
              </b-form>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col md="8">
          <vendors-table :userRoute="getRoute" :enterprise_id="enterprise.id" v-if="enterprise"></vendors-table>
          <users :enterprise="enterprise"></users>
        </b-col>
      </b-row>
    </b-container>
    <enterprise-invite :userRoute="inviteLink"></enterprise-invite>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import errorsMixin from '@/mixins/errors-mixin.js';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import FileInput from '@/components/Inputs/FileInput';
import EnterpriseInvite from '@/views/Components/Modals/EnterpriseInvite';
import VendorsTable from '@/views/Components/Tables/VendorsTable';
import Users from './Users';

export default {
  mixins: [errorsMixin],
  components: {
    FileInput,
    EnterpriseInvite,
    VendorsTable,
    Users
  },
  data() {
    return {
      enterprise: null,
      file: []
    }
  },
  computed: {
    ...mapGetters({
      userRoute: 'profile/userRoute',
      observedRoute: 'observed/observedRoute'
    }),
    getRoute() {
      return this.$route.params.user ? this.observedRoute : this.userRoute;
    },
    inviteLink() {
      return this.getRoute + '/enterprises/' + this.$route.params.enterprise;
    }
  },
  methods: {
    async getEnterprise() {
      await axios.get(this.getRoute + "/enterprises/" + this.$route.params.enterprise)
      .then(response => {
        this.enterprise = response.data;
      })
      .catch(error => {
        this.$router.push("/");
      });
    },
    async update() {
      let formData = new FormData();

      formData.append('name', this.enterprise.name);
      formData.append('primary_color', this.enterprise.primary_color);
      formData.append('secondary_color', this.enterprise.secondary_color);

      if (this.file.length > 0) {
        formData.append('file', this.file[0]);
      }

      formData.append('_method', 'PATCH');

      await axios.post(this.getRoute + "/enterprises/" + this.enterprise.slug, formData, {
        headers: {
          'Content-Type': "multipart/form-data; charset=utf-8; boundary=" + Math.random().toString().substr(2)
        }
      })
      .then(response => {
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        }).then(result => {
          this.getEnterprise();
        });
      })
      .catch(error => {
        this.error(error);
      });
    },
    logoUpload(logo) {
      this.file = logo;
    },
    copyInviteLink() {
      this.$refs.inviteLink.focus();
      document.execCommand('copy');
      swal.fire({
        title: `Success`,
        text: 'Link copied successfully',
        showConfirmButton: false,
        timer: 1750,
        icon: 'success'
      });
    }
  },
  created() {
    this.getEnterprise();
  },
  mounted() {
    document.title = 'Enterprise | ClarityNOW';
  },
  watch: {
    '$route.params.enterprise'(to) {
      this.getEnterprise();
    }
  }
};
</script>